// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"7": "82f0a95eafc47376","846": "b922ae83207ec569",}[chunkId] + ".css"
}